type TRPCErrorWithStatus = {
  meta?: {
    response?: {
      status?: number;
    };
  };
};

export function getTRPCErrorStatus(error: unknown): number | undefined {
  // Legacy cast - may or may not be necessary
  // eslint-disable-next-line replo/no-as-cast
  return (error as TRPCErrorWithStatus)?.meta?.response?.status;
}
